import {
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/core/service/auth.service";
import { ChatService } from "../../service/chat.service";
import { EnquiryService } from "../../service/enquiry.service";

@Component({
  selector: "app-chat-box",
  templateUrl: "./chat-box.component.html",
  styleUrls: ["./chat-box.component.scss"],
})
export class ChatBoxComponent implements OnInit, OnDestroy {
  @ViewChild("mainText") mainText: ElementRef;
  @Output() callNotify = new EventEmitter();

  public open: boolean = false;
  public minimize: boolean = false;

  public user: any;

  public chatData: any;
  public editData: any;
  public replyMsg: string = "";
  public ssn: string = "";

  public getMessage$: any;

  constructor(
    private chatService: ChatService,
    private enquireService: EnquiryService,
    public toastr: ToastrService,
    private auth: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.user = this.auth.userValue;
    $("#chatDiv").hide();

    if (this.user.role == "admin") {
      this.getMessage$ = this.enquireService.openPopup$.subscribe((data) => {
        if (data) {
          this.openChatBox(data);
        }
      });
    }
    // this.minimize = true;
    // this.open = true;
  }

  autoFocusFn() {
    setTimeout(() => {
      this.mainText.nativeElement.focus();
    }, 1000);
  }

  public getChat() {
    this.chatService.getChat(this.ssn).subscribe(
      (res) => {
        let data: any = res;
        this.editData = [];
        if (data.enquiryChat) {
          data.enquiryChat.forEach((e) => {
            // if (e.reply) {
            //   e["editable"] = false;
            //   this.editData.push(e);
            // } else {
            e["editable"] = false;
            this.editData.push(e);
            // }
          });
        }
        this.chatData = data.enquiryChat;
        this.open = true;
        this.minimize = true;
        this.openFullChat();
        this.scrollToBottom();
      },
      (err) => {
        this.toastr.error("No messages?!", "Error");
      }
    );
  }

  scrollToBottom() {
    if (this.chatData.length > 0) {
      setTimeout(() => {
        var elmnt = document.getElementById("scrollMe");
        // elmnt.scrollIntoView(false);
        elmnt.scrollTop = elmnt.scrollHeight;
      }, 250);
    }
  }

  public sendReply(data, enquiryId?) {
    if (!data) {
      this.toastr.error("Your message is empty!", "Error");
      return;
    }

    let enqId;

    if (enquiryId) {
      enqId = enquiryId;
    } else {
      enqId = this.chatData[this.chatData.length - 1].enquiryId;
    }

    let sendData = {
      EnquiryId: enqId,
      Reply: data,
    };
    this.chatService.reply(sendData).subscribe(
      (res) => {
        this.callNotify.emit();
        this.replyMsg = "";
        this.toastr.success("Message sent!", "Success");
        this.getChat();
        if (this.router.routerState.snapshot.url == "/Enquiry") {
          this.reloadCurrentRoute();
        }
      },
      (err) => {}
    );
  }

  private reloadCurrentRoute() {
    // reload current route
    let currentUrl = this.router.routerState.snapshot.url;
    this.router.navigateByUrl('/Home', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
  });
  }

  public closeChat() {
    this.minimize = false;
    this.chatData = [];
    this.open = false;
    $("#chatDiv").hide("slow");
  }

  public openChatBox(data: any) {
    this.ssn = data.socialSecurityNumber;
    this.getChat();
  }

  public minimizeChat() {
    this.minimize = true;
    this.open = false;

    $("#chatDiv").hide("slow");
  }

  public openFullChat() {
    // this.open = true;
    // this.minimize = false;

    $("#chatDiv").show("slow");
    this.autoFocusFn();
  }

  ngOnDestroy(): void {
    if (this.getMessage$) {
      this.getMessage$.unsubscribe();
    }
  }
}
